<template>
    <b-container class="p-0">
        <b-row class="my-1" v-for="([prop , value], index) in Parameter.getProperties()" :key="prop + index">
                <!-- @Todo : Translate -->
                <b-col cols="3" class="m-auto">{{ prop }}</b-col>
                <b-col>
                    <div v-if="prop == 'Options'">
                    <b-row  v-for="(item, index) in Parameter[prop]" :key="index" class="py-1">
                        <b-col>
                            <b-form-input v-model="item.key" />
                        </b-col>
                        <b-col>
                            <b-form-input v-model="item.value" />
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="d-flex justify-content-center align-items-center py-1">
                            <b-button class="rounded-pill btn-outline-secondary bg-white" 
                                style="font-size: xx-small; right: 0; padding-right:7px; padding-left:7px; padding-bottom: 4px; padding-top: 4px;" @click="addOption()">
                                <font-awesome-icon :icon="['fas', 'plus']" />
                            </b-button>
                        </b-col>
                    </b-row>
                    </div>
                    <b-form-input v-else-if="typeof value === 'string'" v-model="Parameter[prop]" />
                </b-col>
            </b-row>
    </b-container>
</template>

<script lang="ts">

    import { Prop, Vue} from 'vue-property-decorator';
    import Component from 'vue-class-component';
    import VueI18n from 'vue-i18n' // translation support
    import locales from "../locales/ParametersItems.json";
    import RadioGroupField from '../Class/RadioGroupField';

    Vue.use(VueI18n);

    @Component({
        i18n: { messages: locales }
    })
	export default class RadioGroupModal extends Vue{
        /** Variant de couleur à appliquer sur le composant */
        @Prop({default: () => "secondary"})
		public Variant!: string;

        @Prop()
        public Parameter!: RadioGroupField;

        private addOption(){
            this.Parameter.Options.push({key: '', value: '' })
        }
    }
</script>

<style scoped>
    :deep(input[type=checkbox]:checked) {
        /** Change la couleur de la checkbox */
        accent-color: var(--Variant) !important;
    }

    :deep(input[type=radio]:checked) {
        /** Change la couleur du bouton radio */
        accent-color: var(--Variant) !important;
    }

    /** Pour que la page active prenne en compte la couleur de Variant */
    :deep(.page-item.active .page-link) {
        background-color: var(--Variant) !important;
    }

    :deep(.page-link:hover) {
        background-color: var(--VariantLight) !important;
    }
</style>